import { styled } from 'inlines'
import { useState, useEffect } from 'react'
import { ImageProps } from './Image'
import { resizeImage } from '@app/util/helpers'
import useMediaQuery from '@app/util/useMediaQuery'

type ImageWithFallbackProps = {
  src?: string
  fallback: string
} & Omit<ImageProps, 'src'>

export const ImageWithFallback = ({
  style,
  src,
  fallback,
  alt,
  resizeWidth = 1024,
  resizeHeight,
  onClick,
  onError,
}: ImageWithFallbackProps) => {
  const isMobile = useMediaQuery()
  const [hasError, setHasError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (src) {
      setHasError(false)
      setIsLoaded(false)
      const img = new Image()
      img.onload = () => {
        setIsLoaded(true)
      }
      img.src = src
    }
  }, [src])

  const handleError = () => {
    onError?.()
    setHasError(true)
  }

  const dimension = resizeHeight ? 'h' : 'w'
  const value = resizeHeight ?? resizeWidth

  if (!isLoaded || hasError || !src) {
    return (
      <styled.img
        src={resizeImage(fallback, value, dimension, isMobile)}
        alt={alt || ''}
        onClick={onClick}
        onError={handleError}
        draggable="false"
        style={style}
      />
    )
  }

  return (
    <styled.img
      src={resizeImage(src, value, dimension, isMobile)}
      alt={alt || ''}
      onClick={onClick}
      onError={handleError}
      draggable="false"
      style={{
        ...style,
      }}
    />
  )
}
